import React from 'react'

const GenericNotFOund = () => {
  return (
    <div>Not Found</div>
  )
}

export default GenericNotFOund